var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"height":"1.56rem"}},_vm._l((_vm.items),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item.url}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }